import React, { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

export const NavBar = ({ isMenuOpen }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDropdownClick = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index); // Toggle dropdown
  };

  const menuItems = [
    { title: "Home", link: "/" },
    {
      title: "About Us",
      dropdown: [
        { title: "Our History", link: "/about/history" },
        { title: "Mission & Vision", link: "/about/mission" },
        { title: "Leadership", link: "/about/leadership" },
      ],
    },
    {
      title: "Academics",
      dropdown: [
        { title: "Programs", link: "/" },
        { title: "Faculty", link: "/" },
      ],
    },
    {
      title: "Admissions",
      dropdown: [
        { title: "Apply Now", link: "/" },
        { title: "Fees & Financial Aid", link: "/" },
      ],
    },
    { title: "Contact", link: "/contact" },
  ];

  return (
    <nav className="text-[#556d89] ">
      <div className="container mx-auto px-4 flex items-center justify-between relative">
        {/* Menu Items */}
        <div
          className={`lg:flex justify-start items-center transition-all duration-300 w-full lg:w-auto ${
            isMenuOpen ? "block" : "hidden"
          }`}
        >
          <ul className="flex flex-col sm:flex-row  sm:space-x-8 mt-4 sm:mt-0 sm:items-center">
            {menuItems.map((item, index) => (
              <li key={index} className="relative group lg:cursor-pointer">
                {/* Main Menu Item */}
                <div
                  className="flex items-center justify-between"
                  onClick={() => handleDropdownClick(index)}
                >
                  <a
                    href={item.link}
                    className="block text-xl font-medium py-2 relative hover:before:content-[''] hover:before:block hover:before:w-[130%] hover:before:h-1 hover:before:bg-red-600 hover:before:absolute hover:before:bottom-[-1px] hover:before:left-[-15%]"
                  >
                    {item.title}
                  </a>
                  {item.dropdown && (
                    <ChevronDownIcon className="h-5 w-5 ml-1 text-[#556d89]" />
                  )}
                </div>

                {/* Dropdown Menu */}
                {item.dropdown && (
                  <ul
                    className={`absolute top-full left-0 bg-white shadow-lg rounded-lg mt-2 border w-40 lg:w-auto z-50 ${
                      activeDropdown === index ? "block" : "hidden"
                    }`}
                  >
                    {item.dropdown.map((subItem, subIndex) => (
                      <li key={subIndex} className="whitespace-nowrap">
                        <a
                          href={subItem.link}
                          className="block px-4 py-2 text-sm hover:bg-gray-100 hover:text-red-600"
                        >
                          {subItem.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};
